import { csx } from '@vtex/admin-ui'

export const styles = {
  flex: csx({
    display: 'flex',
    gap: '$space-1',
    flexDirection: 'column',
  }),
  field: csx({
    '> div': {
      width: '100%',
      '> input': {
        width: '100%',
      },
    },
    '[data-error="true"] > div > input': {
      ':hover': {
        border: '$form.criticalHover',
      },
      border: '$form.critical',
    },
  }),
}
